import { useState } from "react";
import { useInterval } from "./hookUtils";

export function useAnimateText(values : string[]){

    const [value, setValue] = useState<string>("");
    const [valueIndex, setValueIndex] = useState<number>(0);
    const [delay, setDelay] = useState<number>(50);

    useInterval(() => {
        const fullValue = values[valueIndex];
        if(value.length < fullValue.length){
            setValue(fullValue.substring(0,value.length + 1));
            if(value.length === fullValue.length -1){
                //Pause on final character
                setDelay(2000);
            }
        }else{
            if(valueIndex < values.length - 1){
                setValueIndex(prevValue => prevValue + 1);
            }else{
                setValueIndex(0);
            }
            setDelay(50);
            setValue("");
        }
    }, delay);

    return {
        value
    }
}